/**
 * 存储工具类型和项目类型与工具的关联
 */

import { PROJECT_CATEGORY } from "./project-category"

import { ReactComponent as ProjectSvg } from '@/baseui/c1/icons/project.svg'
import { ReactComponent as TaskSvg } from '@/baseui/c1/icons/task.svg'
import { ReactComponent as AuditSvg } from '@/baseui/c1/icons/audit.svg'
import { ReactComponent as NoticeSvg } from '@/baseui/c1/icons/notice.svg'
import { ReactComponent as AssessmentSvg } from '@/baseui/c1/icons/assessment.svg'
import { ReactComponent as MeetingSvg } from '@/baseui/c1/icons/meeting.svg'
import { ReactComponent as ActivitySvg } from '@/baseui/c1/icons/activity.svg'
import { ReactComponent as CalendarSvg } from '@/baseui/c1/icons/calendar.svg'

import { ReactComponent as SendNoticeSvg } from '@/baseui/c1/icons/send-notice.svg'
import { ReactComponent as SendTaskSvg } from '@/baseui/c1/icons/send-task.svg'
import { ReactComponent as MeetingMinuteSvg } from '@/baseui/c1/icons/meeting-record.svg'
import { ReactComponent as WarehousingInSvg } from '@/baseui/c1/icons/warehousing-in.svg'
import { ReactComponent as WarehousingOutSvg } from '@/baseui/c1/icons/warehousing-out.svg'
import { ReactComponent as ReimbursementSvg } from '@/baseui/c1/icons/reimbursement.svg'
import { ReactComponent as ValueAddedSvg } from '@/baseui/c1/icons/value-added.svg'
import { ReactComponent as NegativeListSvg } from '@/baseui/c1/icons/negative-list.svg'
import { ReactComponent as BorrowMoneySvg } from '@/baseui/c1/icons/borrow-money.svg'
import { ReactComponent as LeaveSvg } from '@/baseui/c1/icons/leave.svg'
import { ReactComponent as FolderSvg } from '@/baseui/c1/icons/folder.svg'
import { ReactComponent as DeepSeekSvg } from '@/baseui/c1/icons/deepseek-color.svg'
import { ReactComponent as DocumentSvg } from '@/baseui/c1/icons/document.svg'

import { ReactComponent as AuthorizeSvg } from '@/baseui/c1/icons/authorize.svg'
import { ReactComponent as PriceOfferSvg } from '@/baseui/c1/icons/price-offer.svg'
import { ReactComponent as ProjectBidSvg } from '@/baseui/c1/icons/project-bid.svg'
import { ReactComponent as ProjectContractSvg } from '@/baseui/c1/icons/project-contract.svg'
import { ReactComponent as BudgetSvg } from '@/baseui/c1/icons/budget.svg'
import { ReactComponent as PlanSvg } from '@/baseui/c1/icons/plan.svg'
import { ReactComponent as PurchaseBlueSvg } from '@/baseui/c1/icons/purchase-blue.svg'
import { ReactComponent as WbsSvg } from '@/baseui/c1/icons/wbs.svg'
import { ReactComponent as ScheduleSvg } from '@/baseui/c1/icons/schedule.svg'
import { ReactComponent as QualitySvg } from '@/baseui/c1/icons/quality.svg'
import { ReactComponent as CostingSvg } from '@/baseui/c1/icons/costing.svg'

import { ReactComponent as AttendanceSvg } from '@/baseui/c1/icons/attendance.svg'
import { ReactComponent as RecordSvg } from '@/baseui/c1/icons/record.svg'
import { ReactComponent as GoalSvg } from '@/baseui/c1/icons/goal.svg'

import { ReactComponent as QuerySvg } from '@/baseui/c1/icons/query.svg'
import { ReactComponent as PermissionSvg } from '@/baseui/c1/icons/permission.svg'
import { ReactComponent as PurchaseSvg } from '@/baseui/c1/icons/purchase.svg'
import { ReactComponent as ScrapSvg } from '@/baseui/c1/icons/scrap.svg'

import { ReactComponent as OrganizationSvg } from '@/baseui/c1/icons/organization.svg'
import { ReactComponent as AddressBookSvg } from '@/baseui/c1/icons/address-book.svg'
import { ReactComponent as SoftwareSvg } from '@/baseui/c1/icons/software.svg'
import { ReactComponent as AccountSvg } from '@/baseui/c1/icons/account.svg'
import { ReactComponent as AptitudeSvg } from '@/baseui/c1/icons/aptitude.svg'
import { ReactComponent as ConceptSvg } from '@/baseui/c1/icons/concept.svg'
import { ReactComponent as BookSvg } from '@/baseui/c1/icons/book.svg'
import { ReactComponent as PaperSvg } from '@/baseui/c1/icons/paper.svg'
import { ReactComponent as CourseSvg } from '@/baseui/c1/icons/course.svg'

import { ReactComponent as JobSvg } from '@/baseui/c1/icons/job.svg'
import { ReactComponent as ManageSvg } from '@/baseui/c1/icons/manage.svg'
import { ReactComponent as QuotaSvg } from '@/baseui/c1/icons/quota.svg'
import { ReactComponent as StructureStandardSvg } from '@/baseui/c1/icons/structure-standard.svg'
import { ReactComponent as SoftwareStandardSvg } from '@/baseui/c1/icons/software-standard.svg'
import { ReactComponent as InstallStandardSvg } from '@/baseui/c1/icons/inatall-standard.svg'
import { ReactComponent as OfficeSvg } from '@/baseui/c1/icons/office.svg'
import { ReactComponent as EngineeringSvg } from '@/baseui/c1/icons/engineering.svg'
import { ReactComponent as ConsumableSvg } from '@/baseui/c1/icons/consumable.svg'
import { ReactComponent as GiftSvg } from '@/baseui/c1/icons/gift.svg'
import { ReactComponent as UiComponentSvg } from '@/baseui/c1/icons/ui-component.svg'
import { ReactComponent as DevComponentSvg } from '@/baseui/c1/icons/dev-component.svg'
import { ReactComponent as AlgorithmSvg } from '@/baseui/c1/icons/algorithm.svg'
import { ReactComponent as ProjectGreenSvg } from '@/baseui/c1/icons/project-green.svg'
import { ReactComponent as EditSvg } from '@/baseui/c1/icons/edit.svg'
import { ReactComponent as EditAddSvg } from '@/baseui/c1/icons/edit-add.svg'
import { ReactComponent as EditDeleteSvg } from '@/baseui/c1/icons/edit-delete.svg'
import { ReactComponent as EditModifySvg } from '@/baseui/c1/icons/edit-modify.svg'
import { ReactComponent as SelectSvg } from '@/baseui/c1/icons/lib-select.svg'
import { ReactComponent as UploadSvg } from '@/baseui/c1/icons/lib-upload.svg'
import { ReactComponent as DownloadSvg } from '@/baseui/c1/icons/lib-download.svg'

import { NoticeTodoType } from "./notice-type"
import { PropertyTypeStr } from "./property-type"
import { INSTITUTION_ID } from "./institution-type"
import { emitter, EMITTER_TYPE } from "@/store/mitt"
import { AuthCategory, AuthMenuCode } from "./auth"


export const RsToolProject = {
    /**
     * 预算
     */
    'budget': [PROJECT_CATEGORY.INSITITUTION, PROJECT_CATEGORY.PROJECT],
    /**
     * wbs
     */
    'wbs': [PROJECT_CATEGORY.INSITITUTION, PROJECT_CATEGORY.PROJECT],
    /**
     * 质量
     */
    'quality': [PROJECT_CATEGORY.INSITITUTION, PROJECT_CATEGORY.PROJECT],
    /**
     * 成本
     */
    'cost': [PROJECT_CATEGORY.INSITITUTION, PROJECT_CATEGORY.PROJECT],
}

/**工具类型 */
export const ToolCategory = {
    TODO: 1, // 待办
    COMMON: 2, // 通用
    PROFESSIONAL: 3, // 项目管理
    ASSESS: 4, // 评估
    LIBRARY_TODO: 5, // 库待办
    LIBRARY_GENERAL: 6, // 库通用功能
    LIBRARY_COMMON: 7, // 库常用
    LIBRARY_SYSTEM: 8, // 库体系
    LIBRARY_STASH: 9, // 库仓库
    LIBRARY_DEV: 10, // 库服务器
    LIBRARY_EDIT: 11 // 库增删改
}

export interface Tool {
    value: number; // 工具的值，唯一
    key?: string; // 工具的标识，不能重复，与路由比较来判断工具是否选中
    title?: string; // 名称,
    icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>> // 图标
    url?: string // 路由
    category?: number // 分类
    noticeTodoType?: string // 待办通知的类型
    onClick?: () => void; // 点击事件

    needAuth?: boolean // 是否需要权限
    authGroup?: { [key: number]: AuthCategory[] }   // 权限组,即正常显示这个工具和能够正常onClick所需的最小权限
    isProject?: boolean // 是否是库工具权限,

    isOr?: boolean
}

/**工具清单 */
export const ToolList: Tool[] = [
    // { value: 1, category: 1, key: 'project-profile', title: '项目', icon: ProjectSvg, url: 'project-profile' },
    // { value: 2, category: 1, key: 'todolist', title: '待办', icon: TaskSvg, noticeTodoType: NoticeTodoType.TASK, url: 'todolist' },
    // { value: 8, category: 1, key: 'calendar', title: '日历', icon: CalendarSvg },


    // {
    //     value: 101, category: 2, key: 'send-notice', title: '发通知', icon: SendNoticeSvg, url: 'send-notice', onClick: () => {
    //         emitter.emit(EMITTER_TYPE.SEND_NOTICE);
    //     }
    // },
    // {
    //    value: 102, category: 2, key: 'send-task', title: '发任务', icon: SendTaskSvg, url: 'send-task', onClick: () => {
    //         emitter.emit(EMITTER_TYPE.SEND_TASK);
    //     }
    // },
    { value: 103, category: 2, key: 'meeting-record', title: '会议纪要', icon: MeetingMinuteSvg, url: 'meeting-record' },
    // { value: 104, category: 2, key: 'inbounds', title: '入库', icon: WarehousingInSvg, url: 'inbounds' },
    // { value: 105, category: 2, key: 'outbounds', title: '出库', icon: WarehousingOutSvg, url: 'outbounds' },
    // { value: 106, category: 2, key: 'Reimbursement', title: '报销', icon: ReimbursementSvg },
    // { value: 109, category: 2, key: 'borrow-money', title: '借款', icon: BorrowMoneySvg, url: 'borrow-money' },
    // { value: 110, category: 2, key: 'ask-for-leave', title: '请假', icon: LeaveSvg, url: 'ask-for-leave' },
    // {
    //     value: 111, category: 2, key: 'report', title: '报告', icon: DocumentSvg, url: 'report'
    // },
    // { value: 112, category: 2, key: 'files', title: '文件夹', icon: FolderSvg, url: 'files' },

    // { value: 201, category: 3, key: 'accredit', title: '授权', icon: AuthorizeSvg, url: 'accredit' },
    // { value: 212, category: 3, key: 'charter', title: '章程', icon: RecordSvg, url: 'charter' },
    // { value: 205, category: 3, key: 'allowance', title: '预算', icon: BudgetSvg, url: 'allowance' },
    // { value: 202, category: 3, key: 'price-offer', title: '报价', icon: PriceOfferSvg },
    // { value: 203, category: 3, key: 'project-bid', title: '投标', icon: ProjectBidSvg },
    // { value: 204, category: 3, key: 'project-contract', title: '签约', icon: ProjectContractSvg },
    // { value: 206, category: 3, key: 'plan', title: '计划', icon: PlanSvg, url: 'plan' },
    // { value: 208, category: 3, key: 'wbs', title: 'WBS', icon: WbsSvg, url: 'wbs' },
    // { value: 207, category: 3, key: 'purchase', title: '采购', icon: PurchaseBlueSvg, url: 'purchase' },
    // { value: 209, category: 3, key: 'schedule', title: '进度', icon: ScheduleSvg },
    // { value: 210, category: 3, key: 'quality', title: '质量', icon: QualitySvg, url: 'quality' },
    // { value: 211, category: 3, key: 'cost', title: '成本', icon: CostingSvg, url: 'cost' },
    // { value: 213, category: 3, key: 'log', title: '日志', icon: RecordSvg, url: 'log' },

    // { value: 301, category: 4, key: 'attendance', title: '考勤', icon: RecordSvg, url: 'attendance' },
    // { value: 302, category: 4, key: 'execution', title: '执行力', icon: AttendanceSvg, url: 'execution' },
    // { value: 303, category: 4, key: 'performance', title: '绩效', icon: AttendanceSvg, url: 'performance' },
    // { value: 304, category: 4, key: 'value-added', title: '价值贡献', icon: ValueAddedSvg, url: 'value-added' },
    // { value: 305, category: 4, key: 'negative-list', title: '负面清单', icon: NegativeListSvg, url: 'negative-list' },
    // { value: 306, category: 4, key: 'income', title: '收入', icon: GoalSvg, url: 'income' },

    // { value: 350, category: 4, key: 'organization', title: '差旅', icon: RecordSvg, url: 'organization' },

    // { value: 401, category: 5, key: "query", title: "查询", icon: QuerySvg },
    // { value: 402, category: 5, key: "task", title: "任务", icon: TaskSvg },
    // { value: 403, category: 5, key: "notice", title: "通知", icon: NoticeSvg },
    // {
    //     value: 404, category: 6, key: "permission", title: "权限设置", icon: PermissionSvg, url: 'permission',
    //     needAuth: true, authGroup: { [AuthMenuCode.AUTH]: [AuthCategory.UPDATE] },
    // },
    // {
    //     value: 438, category: 6, key: "purchase", title: "采购", icon: PurchaseSvg, url: 'purchase',
    //     needAuth: true, authGroup: { [AuthMenuCode.PURCHASE]: [AuthCategory.CREATE] }
    // },
    // { value: 405, category: 6, key: "outbounds", title: "出库", icon: WarehousingOutSvg },
    // { value: 406, category: 6, key: "inbounds", title: "入库", icon: WarehousingInSvg },
    // { value: 407, category: 6, key: "scrap", title: "报废", icon: ScrapSvg },

    // {
    //     value: 408, category: 7, key: 'organization', title: '组织', icon: OrganizationSvg, url: 'organization',
    //     needAuth: true, authGroup: { [AuthMenuCode.ORGANIZATION]: [AuthCategory.READ] }
    // },
    // {
    //     value: 409, category: 7, key: 'address-book', title: '通讯录', icon: AddressBookSvg, url: 'address-book',
    //     needAuth: true, authGroup: { [AuthMenuCode.CONTACT]: [AuthCategory.READ] }
    // },
    // {
    //     value: 410, category: 7, key: "software", title: "软件", icon: SoftwareSvg, url: "software",
    //     needAuth: true, authGroup: { [AuthMenuCode.SOFTWARE]: [AuthCategory.READ] }
    // },
    // {
    //     value: 411, category: 7, key: "account", title: "账号", icon: AccountSvg, url: "account",
    //     needAuth: true, authGroup: { [AuthMenuCode.ACCOUNT]: [AuthCategory.READ] }
    // },
    // {
    //     value: 412, category: 7, key: "qualification", title: "资信", icon: AptitudeSvg, url: "qualification",
    //     needAuth: true, authGroup: { [AuthMenuCode.QUALITY]: [AuthCategory.READ] }
    // },
    // {
    //     value: 413, category: 7, key: "knowledge", title: "知识", icon: BookSvg, url: "knowledge",
    //     needAuth: true, isOr: true,
    //     authGroup: {
    //         [AuthMenuCode.CONCEPT]: [AuthCategory.READ],
    //         [AuthMenuCode.BOOK]: [AuthCategory.READ],
    //         [AuthMenuCode.COURSE]: [AuthCategory.READ],
    //         [AuthMenuCode.PAPER]: [AuthCategory.READ],
    //     }
    // },
    // {
    //     value: 426, category: 8, key: "office", title: "办公设备", icon: OfficeSvg, url: `property/${PropertyTypeStr.OFFICE}`,
    //     needAuth: true, authGroup: { [AuthMenuCode.OFFICE_DEVICE]: [AuthCategory.READ] },
    // },
    // {
    //     value: 427, category: 8, key: "device", title: "工程设备", icon: EngineeringSvg, url: `property/${PropertyTypeStr.DEVICE}`,
    //     needAuth: true, authGroup: { [AuthMenuCode.ENGINEERING_DEVICE]: [AuthCategory.READ] },
    // },
    // {
    //     value: 428, category: 8, key: "consumables", title: "耗材", icon: ConsumableSvg, url: `property/${PropertyTypeStr.CONSUMABLES}`,
    //     needAuth: true, authGroup: { [AuthMenuCode.CONSUMABLE]: [AuthCategory.READ] },
    // },
    // {
    //     value: 429, category: 8, key: "gifts", title: "礼品", icon: GiftSvg, url: `property/${PropertyTypeStr.GIFTS}`,
    //     needAuth: true, authGroup: { [AuthMenuCode.GIFT]: [AuthCategory.READ] },
    // },

    // {
    //     value: 430, category: 9, key: "ui-component", title: "UI组件", icon: UiComponentSvg, url: "ui-component",
    //     needAuth: true, authGroup: { [AuthMenuCode.UI_COMPONENT]: [AuthCategory.READ] }
    // },
    // {
    //     value: 431, category: 9, key: "dev-component", title: "开发组件", icon: DevComponentSvg, url: "dev-component",
    //     needAuth: true, authGroup: { [AuthMenuCode.DEV_COMPONENT]: [AuthCategory.READ] }
    // },
    // { value: 432, category: 9, key: "API", title: "API", icon: DevComponentSvg },
    // {
    //     value: 433, category: 9, key: "algorithm", title: "算法", icon: AlgorithmSvg, url: "algorithm",
    //     needAuth: true, authGroup: { [AuthMenuCode.ALGORITHM]: [AuthCategory.READ] }
    // },
    // {
    //     value: 434, category: 9, key: "project-lib", title: "项目", icon: ProjectGreenSvg, url: 'project-lib/',
    //     needAuth: true, authGroup: { [AuthMenuCode.PROJECT]: [AuthCategory.READ] },
    // },
    // {
    //     value: 417, category: 10, key: "management-framework", title: "制度", icon: ManageSvg, url: 'archi-system/management-framework',
    //     needAuth: true, authGroup: { [AuthMenuCode.RULE]: [AuthCategory.READ] }
    // },
    // {
    //     value: 418, category: 10, key: "job-specification", title: "职位", icon: JobSvg, url: 'archi-system/job-specification',
    //     needAuth: true, authGroup: { [AuthMenuCode.POSITION]: [AuthCategory.READ] },
    // },
    // {
    //     value: 419, category: 10, key: "quota", title: "定额", icon: QuotaSvg, url: 'archi-system/quota',
    //     needAuth: true, authGroup: { [AuthMenuCode.QUOTA]: [AuthCategory.READ] },
    // },
    // {
    //     value: 420, category: 10, key: "structure-standard", title: "结构", icon: StructureStandardSvg, url: 'archi-system/structure-standard',
    //     needAuth: true, authGroup: { [AuthMenuCode.STRUCTURE]: [AuthCategory.READ] },
    // },
    // {
    //     value: 421, category: 10, key: "engineering-standard", title: "工程", icon: InstallStandardSvg, url: 'archi-system/engineering-standard',
    //     needAuth: true, authGroup: { [AuthMenuCode.ENGINEERING]: [AuthCategory.READ] },
    // },
    // {
    //     value: 422, category: 10, key: "software-standard", title: "软件", icon: SoftwareStandardSvg, url: 'archi-system/software-standard',
    //     needAuth: true, authGroup: { [AuthMenuCode.SOFTWARE_STANDARD]: [AuthCategory.READ] },
    // },
    // {
    //     value: 423, category: 10, key: "hardware-standard", title: "硬件", icon: InstallStandardSvg, url: 'archi-system/hardware-standard',
    //     needAuth: true, authGroup: { [AuthMenuCode.HARDWARE_STANDARD]: [AuthCategory.READ] },
    // },
    // {
    //     value: 424, category: 10, key: "project-management-standard", title: "项目管理", icon: InstallStandardSvg, url: 'archi-system/project-management-standard',
    //     needAuth: true, authGroup: { [AuthMenuCode.PROJECT_MANAGE]: [AuthCategory.READ] },
    // },
    // { value: 425, category: 10, key: "tool-library", title: "工具", icon: InstallStandardSvg },

    // {
    //     value: 435, category: 11, key: "edit-add", title: "增", icon: EditAddSvg, onClick: () => {
    //         emitter.emit(EMITTER_TYPE.COMMON_CREATE);
    //     }
    // },
    // {
    //     value: 436, category: 11, key: "edit-delete", title: "删", icon: EditDeleteSvg, onClick: () => {
    //         emitter.emit(EMITTER_TYPE.COMMON_DELETE);
    //     }
    // },
    // {
    //     value: 437, category: 11, key: "edit-modify", title: "改", icon: EditModifySvg, onClick: () => {
    //         emitter.emit(EMITTER_TYPE.COMMON_UPDATE);
    //     }
    // },
    // // 从439开始，438上面已经有了
    // {
    //     value: 439, category: 11, key: "edit-select", title: "多选", icon: SelectSvg, onClick: () => {
    //         emitter.emit(EMITTER_TYPE.COMMON_SELECT);
    //     }
    // },
    // {
    //     value: 440, category: 11, key: "edit-upload", title: "上传", icon: UploadSvg, onClick: () => {
    //         emitter.emit(EMITTER_TYPE.COMMON_UPLOAD);
    //     }
    // },
    // {
    //     value: 441, category: 11, key: "edit-download", title: "下载", icon: DownloadSvg, onClick: () => {
    //         emitter.emit(EMITTER_TYPE.COMMON_DOWNLOAD);
    //     }
    // },
]

/**
 * 根据项目分类查询默认的工具
 * @param category
 */
export function getToolListByProjectCategory(category: number, institutionId?: number) {
    switch (category) {
        case PROJECT_CATEGORY.PERSONAL:
            return ToolList.filter(item => item.category == 1 || item.category == 2 || [206, 212, 213, 301, 302, 303, 304, 305, 306].includes(item.value));
        case PROJECT_CATEGORY.PROJECT:
            return ToolList.filter(item => item.category == 1 || item.category == 2 || item.category == 3 || [301, 302, 303, 304, 305, 306].includes(item.value));
        case PROJECT_CATEGORY.INSITITUTION:
            if (institutionId == INSTITUTION_ID.GENERAL_ASSEMBLY || institutionId == INSTITUTION_ID.SUPERVISORY_BOARD) {
                // 股东会、监事会
                return ToolList.filter(item => item.category == 1 || [101, 102, 103, 107, 108, 111, 112, 201, 205, 206, 212, 213, 301, 302, 303, 304, 305, 306].includes(item.value));
            } else if (institutionId == INSTITUTION_ID.BOARD_OF_DIRECTORS) {
                // 董事会
                return ToolList.filter(item => item.category == 1 || [101, 102, 103, 106, 107, 108, 111, 112, 201, 205, 206, 211, 212, 213, 301, 302, 303, 304, 305, 306].includes(item.value));
            } else if (institutionId == INSTITUTION_ID.ADMINISTRATION || institutionId == INSTITUTION_ID.MARKETING_DEPARTMENT) {
                // 行政、市场部
                return ToolList.filter(item => item.category == 1 || item.category == 2 || item.category == 4 || [201, 205, 206, 207, 208, 209, 210, 211, 212, 213].includes(item.value) || item.category == 11);
            } else {
                return ToolList.filter(item => item.category == 1 || item.category == 2 || [201, 205, 206, 207, 208, 209, 210, 211, 212, 213, 301, 302, 303, 304, 305, 306].includes(item.value));
            }
        case PROJECT_CATEGORY.LIBRARY:
            return ToolList.filter(item => item.category >= 5);
        default:
            return ToolList.filter(item => item.category == 1 || item.category == 2 || item.category == 3 || item.category == 4);
    }
}

/**
 * 查询特殊工具
 */
export function getSpecialToolListByProjectCategory(category: number, institutionId?: number) {
    switch (category) {
        case PROJECT_CATEGORY.PERSONAL:
            return [];
        case PROJECT_CATEGORY.PROJECT:
            return [];
        case PROJECT_CATEGORY.INSITITUTION:
            return [];
        // case PROJECT_CATEGORY.FUNCTIONAL:
        //     return [];
        case PROJECT_CATEGORY.LIBRARY:
            return [];
        default:
            return [];
    }
}

